export default function AboutSection() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-block px-4 py-1.5 border border-foreground-300/60 rounded-full text-xs font-medium text-foreground-600 tracking-wide uppercase mb-6">
          Why Spreadsheet Shopping
        </div>

        <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight max-w-3xl mx-auto">
          Because Searching Through Thousands of Listings{" "}
          <span className="inline-flex items-center gap-1 align-middle">
            <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
              <i className="ri-footprint-line text-2xl md:text-3xl text-primary-500"></i>
            </span>
          </span>{" "}
          Should Not Feel Like a{" "}
          <span className="inline-flex items-center gap-1 align-middle">
            <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
              <i className="ri-t-shirt-line text-2xl md:text-3xl text-accent-500"></i>
            </span>
          </span>{" "}
          Treasure Hunt Without a{" "}
          <span className="inline-flex items-center gap-1 align-middle">
            <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
              <i className="ri-file-list-3-line text-2xl md:text-3xl text-foreground-600"></i>
            </span>
          </span>
        </h2>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
          <div className="rounded-xl bg-background-100/70 border border-background-200/50 overflow-hidden group cursor-default">
            <div className="h-40 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Wall%20clock%20showing%20fast%20motion%20next%20to%20a%20laptop%20on%20a%20clean%20white%20desk%2C%20bright%20morning%20light%2C%20productivity%20concept%20photography%2C%20modern%20minimalist%20aesthetic%2C%20warm%20white%20and%20wood%20tones%2C%20clean%20composition&width=600&height=300&seq=about-save-v2&orientation=landscape"
                alt="Save hours of searching with Sugargoo Spreadsheet"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100">
                <i className="ri-time-line text-lg text-primary-600"></i>
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                Save Hours of Searching
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                A well-organized Sugargoo spreadsheet eliminates the need to scroll through endless forum threads. Every product is categorized, rated, and linked directly — saving you hours every week.
              </p>
            </div>
          </div>

          <div className="rounded-xl bg-background-100/70 border border-background-200/50 overflow-hidden group cursor-default">
            <div className="h-40 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20a%20checklist%20document%20on%20a%20wooden%20desk%20with%20green%20checkmarks%2C%20bright%20natural%20light%2C%20quality%20assurance%20concept%20photography%2C%20clean%20professional%20aesthetic%2C%20warm%20wood%20and%20green%20tones&width=600&height=300&seq=about-quality-v2&orientation=landscape"
                alt="Quality verified product links"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100">
                <i className="ri-shield-check-line text-lg text-accent-700"></i>
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                Quality-Verified Links
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                Spreadsheet curators test and verify product quality before adding links. Each item includes quality ratings, sizing notes, and real buyer feedback so you shop with confidence.
              </p>
            </div>
          </div>

          <div className="rounded-xl bg-background-100/70 border border-background-200/50 overflow-hidden group cursor-default">
            <div className="h-40 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Two%20product%20cards%20side%20by%20side%20with%20price%20tags%20on%20a%20minimalist%20white%20desk%2C%20soft%20studio%20lighting%2C%20price%20comparison%20concept%20photography%2C%20clean%20modern%20aesthetic%2C%20white%20and%20warm%20gold%20tones%2C%20organized%20composition&width=600&height=300&seq=about-compare-v2&orientation=landscape"
                alt="Compare prices instantly with Sugargoo Spreadsheet"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100">
                <i className="ri-price-tag-3-line text-lg text-secondary-700"></i>
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                Compare Prices Instantly
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                Side-by-side comparison tables inside every spreadsheet let you evaluate multiple options at a glance. Spot the best deals and avoid overpaying for similar quality items.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}